module.exports = __webpack_public_path__ + "static/media/bg4.41f70806.jpg";